import { createStatePropertySelector } from "app/pages/workspace/sales/helpers";

import { selectCompanySearchStateSlice } from "../../advanced-search/store/selectors";

const select = createStatePropertySelector(selectCompanySearchStateSlice);

export const selectOtherFilters = select("otherFilters");

export const selectWebsitesExportToCrmAs = select("exportToCrmAs");
